import { instance } from "libs/api";

import {
  ImproveMessageRequestBody,
  ImproveMessageResponse
} from "./improveMessage.types";

const ROUTE = "admin/ai/improve-message";

export const requestImproveMessage = async (
  body: ImproveMessageRequestBody
): Promise<ImproveMessageResponse> => {
  return await instance.post(ROUTE, body);
};
